import 'components/generic_list_item';
import LessonPlayer from 'components/lesson_player';
import './index.scss';

class Lesson {
  constructor($context) {
    LessonPlayer.start($context);
    this.$context = $context;
  }
}

export default Lesson;
